<template>

    <form autocomplete="off" class="pl-3" v-on:submit.prevent="close" v-show="loaded">
  
        <h5 class="font-weight-bold">{{ lang.polaris.dashboard.level }}</h5>
        <trax-ui-choice  v-model="form.level" :error="errors.level" :options="level_select" allow-unselect="1">
        </trax-ui-choice>

        <div v-for="(phase_name, type_code) in flight_phases_names" :key="type_code" v-if="data_bi[type_code]">
            <h5 class="font-weight-bold mt-4">{{ phase_name }}</h5>
            <div class="clearfix" v-for="(item, item_id) in data_bi[type_code]" :key="item_id" v-if="!item.title">

                <trax-ui-choice v-model="form.indicators[item_id]" :options="indicator_select"
                    size="xs" plain-icons="1" class="float-left" allow-unselect="1">
                </trax-ui-choice>
                <p style="padding-left:75px; white-space:pre-wrap;">{{ item.name }}</p>

            </div>
        </div>

        <div v-if="data_gc[typeCode]">
            <h5 class="font-weight-bold mt-4">{{ lang.polaris.training.competencies }}</h5>
            <div class="clearfix" v-for="(item, item_id) in data_gc[typeCode]" :key="item_id" v-if="!item.title">

                <trax-ui-choice v-model="form.indicators[item_id]" :options="indicator_select"
                    size="xs" plain-icons="1" class="float-left" allow-unselect="1">
                </trax-ui-choice>
                <p style="padding-left:75px; white-space:pre-wrap;">{{ item.name }}</p>

            </div>
        </div>

        <h5 class="font-weight-bold mt-5">{{ lang.polaris.dashboard.comments }}</h5>
        <trax-ui-input v-model="form.comments" :error="errors.comments" rows="5">
        </trax-ui-input>

        <div class="trax-form-actions text-center">
            <button type="submit" class="btn btn-default btn-round" :disabled="mustSelectLevel && !levelSelected"> {{ lang.polaris.form.close }} </button>
            <div class="text-danger font-weight-bold" v-if="mustSelectLevel && !levelSelected">
                {{ lang.polaris.dashboard.level_must_select }}
            </div>
        </div>
    </form>
    
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-atpl-dashboard-level-report-learner-edit-competencies-select'},
            bus: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/learning-units/'+data.item.id,
                endpointParams: {
                    relations: ['biCompetencyItems', 'gcCompetencyItems']
                },
                loaded: false,
                competency_indexes: {
                    'general-criteria': data.program.gc_index_id,
                    'behavioural-indicator': data.program.bi_index_id,
                },
                assessment_ids: data.assessment_ids,
                flight_phases_names: data.flight_phases_names,
                form: {
                    level: '',
                    comments: '',
                    indicators: {}
                },
                level_select: [
                    {value: 1, name: lang.polaris.dashboard.unsatisfactory, color: 'danger'},
                    {value: 2, name: lang.polaris.dashboard.partially_satisfactory, color: 'warning'},
                    {value: 3, name: lang.polaris.dashboard.satisfactory, color: 'success'},
                ],
                indicator_select: [
                    {value: 1, icon: 'error_outline', color: 'danger'},
                    {value: 3, icon: 'check', color: 'success'},
                ],
                errors: {},
                typeCode: null,
                loaded_data: {},
                data_bi: {},
                data_gc: {},
                indicators: {}
            }
        },

        created: function() {
            this.bus.$on(this.id+'-open', this.initData);
        },

        watch: {
            
            form: function() {
                if (this.loaded) this.setState();
            }
        },

        computed: {

            mustSelectLevel() {
                for (var key of Object.keys(this.form.indicators)) {
                    if (this.form.indicators[key]) {
                        return true
                    }
                }
                return this.form.comments != null && this.form.comments.trim().length > 0
            },

            levelSelected() {
                return this.form.level > 0
            }
        },

        methods: {

            initData(titleAndData) {
                this.loaded = false,
                this.errors = {};
                this.typeCode = titleAndData.data.type_code;
                this.form = titleAndData.data.states;
                this.loadData();
            },
            
            loadData() {
                var that = this;
                axios.get(this.endpoint, { params: this.endpointParams })
                    .then(function (response) {
                        that.loaded_data['behavioural-indicator'] = response.data.data.bi_competency_items;
                        that.loaded_data['general-criteria'] = response.data.data.gc_competency_items;
                        that.loaded = true;
                        that.setData();
                        that.setState();
                    })
                    .catch(function (error) {
                    });
            },
            
            setData() {
                this.data_bi = {};
                this.data_gc = {};
                this.indicators = {};
                this.setAssessmentData('behavioural-indicator');
                this.setAssessmentData('general-criteria');
                this.setIndicators(this.data_bi);
                this.setIndicators(this.data_gc);
            },

            setAssessmentData(assessmentType) {
                for (var index in this.loaded_data[assessmentType]) {
                    var item = this.loaded_data[assessmentType][index];

                    // Group them by type_code
                    if (item.index_id != this.competency_indexes['behavioural-indicator']) {

                        // Competencies
                        if (!this.data_gc[item.type]) this.data_gc[item.type] = {};
                        this.data_gc[item.type][item.uuid] = item;

                    } else {
                        // BIs

                        // Keep only current competency
                        if (!item.competencies || !item.competencies.includes(this.typeCode)) continue;

                        if (!this.data_bi[item.type]) this.data_bi[item.type] = {};
                        this.data_bi[item.type][item.uuid] = item;
                    }
                }
            },

            setState() {
                this.bus.$emit(this.id+'-set', {type_code: this.typeCode, states: this.form, indicators: this.indicators});
            },

            close() {
                this.bus.$emit(this.id+'-close');
            },

            setIndicators(data) {
                for (var index1 in data) {
                    for (var index2 in data[index1]) {
                        var item = data[index1][index2];
                        this.indicators[item.uuid] = item.name;
                    }
                }
            }
        }
    }
</script>
